export default __webpack_public_path__ + "020cb6710a725112a7cabce13a5a4eeb.png";